/* Completa tu rutina · pagina de producto. La eleccion la hace assets/rutina-motor.js */
(function () {
  var root = document.getElementById('crRoot');
  if (!root || root.dataset.ready || !window.LlRutina) return;
  root.dataset.ready = '1';
  var R = window.LlRutina;

  var tags = [];
  try { tags = JSON.parse(root.dataset.tags || '[]'); } catch (e) {}
  var propio = null;
  try { propio = JSON.parse(root.dataset.propio || 'null'); } catch (e) {}
  var actual = root.dataset.paso || '';

  var lista = root.querySelector('.cr-lista');
  var total = root.querySelector('.cr-total__v');
  var cuenta = root.querySelector('.cr-total__n');
  var btn = root.querySelector('.cr-btn');
  var err = root.querySelector('.cr-err');

  function fila(p, paso, fijo) {
    var l = document.createElement('label');
    l.className = 'cr-fila' + (fijo ? ' is-propio' : '');
    l.dataset.variant = p.variantId;
    l.dataset.price = p.price;

    var c = document.createElement('input');
    c.type = 'checkbox'; c.checked = true; c.className = 'cr-check';
    c.setAttribute('aria-label', 'Incluir ' + p.title);
    l.appendChild(c);

    var f = document.createElement('span');
    f.className = 'cr-fig';
    if (p.image) {
      var im = document.createElement('img');
      im.src = p.image; im.alt = ''; im.loading = 'lazy'; im.width = 120; im.height = 120;
      f.appendChild(im);
    }
    l.appendChild(f);

    var info = document.createElement('span');
    info.className = 'cr-info';
    var e = document.createElement('span');
    e.className = 'cr-paso';
    e.textContent = 'Paso ' + paso.n + ' · ' + paso.nombre + (fijo ? ' · Este producto' : '');
    var n = document.createElement('span');
    n.className = 'cr-nombre';
    if (fijo) { n.textContent = p.title; }
    else {
      var a = document.createElement('a');
      a.href = p.url; a.textContent = p.title;
      n.appendChild(a);
    }
    info.appendChild(e); info.appendChild(n);
    l.appendChild(info);

    var pr = document.createElement('span');
    pr.className = 'cr-precio';
    pr.textContent = R.money(p.price);
    l.appendChild(pr);
    return l;
  }

  function actualizar() {
    var n = 0, suma = 0;
    root.querySelectorAll('.cr-fila').forEach(function (f) {
      var c = f.querySelector('input');
      f.classList.toggle('is-off', !c.checked);
      if (c.checked) { n++; suma += parseInt(f.dataset.price, 10) || 0; }
    });
    cuenta.textContent = n === 1 ? '1 producto' : n + ' productos';
    total.textContent = R.money(suma);
    btn.disabled = n === 0;
    btn.textContent = n > 1 ? 'Agregar los ' + n + ' al carrito' : 'Agregar al carrito';
  }

  root.addEventListener('change', function (e) {
    if (e.target.matches('.cr-check')) actualizar();
  });

  btn.addEventListener('click', function () {
    err.hidden = true;
    var ids = [];
    root.querySelectorAll('.cr-fila').forEach(function (f) {
      if (f.querySelector('input').checked) ids.push(f.dataset.variant);
    });
    if (!ids.length) return;
    var txt = btn.textContent;
    btn.disabled = true; btn.textContent = 'Agregando…';
    R.agregar(ids).then(function () {
      btn.textContent = 'Listo, ya está en tu carrito';
      setTimeout(function () { btn.disabled = false; actualizar(); }, 2200);
    }).catch(function (e) {
      btn.disabled = false; btn.textContent = txt;
      err.textContent = (e && e.message && e.message !== 'cart') ? e.message : 'No pudimos agregar los productos. Intenta de nuevo.';
      err.hidden = false;
    });
  });

  R.sugerir({
    tags: tags,
    vendors: [root.dataset.vendor || ''],
    pasos: [actual],
    excluir: propio ? [propio.productId] : []
  }).then(function (res) {
    if (!res.length) return;
    var filas = res.map(function (r) { return { n: r.paso.n, el: fila(r.p, r.paso, false) }; });
    if (propio) {
      var mio = R.PASOS.filter(function (x) { return x.tag === actual; })[0];
      if (mio) filas.push({ n: mio.n, el: fila(propio, mio, true) });
    }
    filas.sort(function (a, b) { return a.n - b.n; }).forEach(function (x) { lista.appendChild(x.el); });
    root.hidden = false;
    actualizar();
  });
})();
